import {Badge, HStack, Icon, Text, VStack} from "@chakra-ui/react";
import {HiOutlineCpuChip, HiOutlinePencil} from "react-icons/hi2";

const WorkerListItem = ({worker, onEdit}) => {
    return (
        <HStack
            p={6}
            borderWidth={1}
            borderColor={'border.secondary'}
            w={'full'}
            borderRadius={12}
            bg={'bg.card'}
            columnGap={6}
            cursor={'pointer'}
            _hover={{bg: 'bg.highlight'}}
            transition="background 0.2s ease-in-out"
            onClick={() => onEdit(worker)}
        >
            <Icon fontSize={46} strokeWidth={0.75} color={'white'}>
                <HiOutlineCpuChip/>
            </Icon>
            <VStack alignItems={'flex-start'} gap={1} flex={1}>
                <HStack gap={2} alignItems={'center'}>
                    <Text color={'white'} fontWeight={500}>{worker.name}</Text>
                    {worker.tag && (
                        <Badge variant={'outline'} colorPalette={'purple'} fontSize={11}>{worker.tag}</Badge>
                    )}
                </HStack>
                {worker.description && (
                    <Text color={'text.grey'} fontSize={13}>{worker.description}</Text>
                )}
            </VStack>
            <Icon fontSize={22} strokeWidth={1.5} color={'text.grey'} _hover={{color: 'white'}} transition="color 0.2s">
                <HiOutlinePencil/>
            </Icon>
        </HStack>
    )
}

export default WorkerListItem;
